import { css } from '@emotion/core';
import { CONTENT_MAX_WIDTH } from 'components/Layout/PageContentWidth';
import { breakpoints } from '../../app/spacing';

const pageBreakpoint = breakpoints.lg;

export const pageSizingStyles = css`
  width: 100%;
  margin: 0 auto;
  // Desired visual width is 1372 with 20px spacing on left/right.
  // (1412 - 1372) / 2 = 20 = gutters.spacing(4)

  padding: 0 15px;
  @media (min-width: ${pageBreakpoint + 1}px) {
    max-width: calc(
      ${CONTENT_MAX_WIDTH} + 40px
    ); // 1372px with 20px spacing on left and right
    padding: 0 20px;
  }
`;

export const navColors = {
  background: 'var(--color-background-white)',
  border: 'var(--color-border-medium-light)',
};
